import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";
import { useSetRecoilState } from "recoil";

import { SVG_MUI } from "@ryde/assets";
import { ViewSwitchWrapper } from "@ryde/layout";
import { useBookingsNavigation } from "@ryde/redux";
import { BookingsViewTypeEnum, Log, selectedIdsSF } from "@ryde/shared";
import { blueGreyMui, deepPurpleMui } from "@ryde/theme";

export const ViewSwitchBookings: FC = () => {
  const {
    isCalendarBookingView,
    navigateBookingsGrid,
    navigateBookingsCalendar,
  } = useBookingsNavigation();
  const setSelectedBookings = useSetRecoilState(selectedIdsSF("booking"));
  const { t } = useTranslation();
  const switchView = useEvent((viewTo: BookingsViewTypeEnum) => {
    Log.debug(`View switch:${BookingsViewTypeEnum[viewTo]}`);
    setSelectedBookings([]);

    if (isCalendarBookingView) {
      navigateBookingsGrid();
    } else {
      navigateBookingsCalendar();
    }
  });
  const colorActive = deepPurpleMui.A700;
  const colorGrey = blueGreyMui.A200;
  const iconColor = useMemo(() => {
    const gridIconColor = !isCalendarBookingView ? colorActive : colorGrey;
    const calendarIconColor = isCalendarBookingView ? colorActive : colorGrey;
    return { gridIconColor, calendarIconColor };
  }, [colorActive, colorGrey, isCalendarBookingView]);
  return (
    <ViewSwitchWrapper
      data-e2e-mode={isCalendarBookingView ? "calendar" : "grid"}
    >
      <SVG_MUI.TableViewSVG
        fill={iconColor.gridIconColor}
        onClick={() => switchView(BookingsViewTypeEnum.Grid)}
        title={t("booking.ui.gridView")}
      />
      <SVG_MUI.CalendarSwitch3SVG
        fill={iconColor.calendarIconColor}
        onClick={() => switchView(BookingsViewTypeEnum.Calendar)}
        title={t("booking.ui.calendarView")}
      />
    </ViewSwitchWrapper>
  );
};
